// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"c6cfedad","238":"29a0dcee","442":"56bd58e2","717":"521a6337"}[chunkId] + ".chunk.js";
};